export const COLLABORATOR_ONBOARDING_STATE_KEYS = {
	COLLABORATOR_ONBOARDING_ELIGIBLE_USER:
		'collaborator-onboarding:isCollaboratorOnboardingEligibleUser',
	COLLABORATOR_ONBOARDING_INLINE_COMMENT_PAGE: 'collaborator-onboarding:mockInlineCommentPageId',
	HAS_DISMISSED_INLINE_COMMENT: 'collaborator-onboarding:hasDismissedInlineComment',
	INVITE_TO_EDIT_NUDGE_SEEN: 'collaborator-onboarding:inviteToEditNudgeSeen',
	INVITE_TO_EDIT_NUDGE_SEEN_BUT_NOT_CLICKED:
		'collaborator-onboarding:inviteToEditNudgeSeenButNotClicked',
};
